import { render } from "./IconInjury.vue?vue&type=template&id=4da2c3da&ts=true"
import script from "./IconInjury.vue?vue&type=script&lang=ts"
export * from "./IconInjury.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__